module.exports = __webpack_public_path__ + "img/oliver-a.3cacf795.png";